module.exports = __webpack_public_path__ + "static/media/BulkReturn5.fffb7bdb.png";